'use client';

import { useState, useCallback } from 'react';
import type { OpdsFeed, LibraryConnection } from '@/lib/opds/types';
import { searchOpds } from '@/lib/utils/fetch';

export function useSearch(library: LibraryConnection | undefined, searchDescUrl: string | undefined) {
  const [results, setResults] = useState<OpdsFeed | null>(null);
  const [resultsFeedUrl, setResultsFeedUrl] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const search = useCallback(async (query: string) => {
    if (!searchDescUrl || !query.trim()) return;
    setLoading(true);
    setError(null);
    try {
      const { feed, searchUrl } = await searchOpds(searchDescUrl, query, library);
      setResults(feed);
      setResultsFeedUrl(searchUrl);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Search failed');
    } finally {
      setLoading(false);
    }
  }, [searchDescUrl, library]);

  const clearResults = useCallback(() => {
    setResults(null);
    setResultsFeedUrl(undefined);
    setError(null);
  }, []);

  return { results, resultsFeedUrl, loading, error, search, clearResults };
}
